import moment from 'moment';
import React, { Component } from 'react'
import { Datos_Empresa, development } from "../../../libs/utils/Const";

const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales

    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },

    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    },
};

class GeneralInvoiceDelivey extends Component {

    DocTimeFormat = (docTime) => {
        let time = (docTime || '').toString();

        if (time.length > 2) {
            let position = time.length - 2;
            time = time.slice(0, position) + ":" + time.slice(position, time.length)
        } else {
            time = `00:${time}`;
        }

        return time;
    }

    render() {
        const { DocsToPrint, ReportsModel } = this.props;

        return (
            <>
                <table><tr><td>

                    <div style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "2.5vw" }}>
                        <div className="row">
                            <div className="col-3">
                                <img src={development ? require('../../../images/logo_draft.svg') : require('../../../images/logo_EMPRESA.svg')} alt="Logo" />
                                <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br />{/*<strong>{"InfoByFolio ? InfoByFolio.folio : ''"}</strong>*/}</p>
                            </div>
                            <div className="col-6 text-center">
                                <h5><strong>INFORME DE VENTAS ({ReportsModel.SucursalName ? ReportsModel.SucursalName : 'Sin sucursal'})</strong></h5>
                            </div>
                            <div className="col-3">
                                {/* <span className="text-left">SUCURSAL: {DocsToPrint[0].currentUser ? DocsToPrint[0].currentUser.Sucursal : 'Sin sucursal'}</span> */}
                                <p>{Datos_Empresa.Calle} #{Datos_Empresa.Numero} <br />COL. {Datos_Empresa.Colonia},{Datos_Empresa.Ciudad}, {Datos_Empresa.Estado}. C.P.{Datos_Empresa.CP}</p>
                            </div>
                        </div>

                        {/* DEVOLUCIONES */}
                        {ReportsModel.checkRefounds &&
                            <div className='row mt-5' style={{ paddingRight: "15px" }}>
                                <div className='col-6 text-left'>
                                    <h6><strong>Devoluciones</strong></h6>
                                </div>
                                <div className='col-6 text-right'>
                                    <h6>Del {moment(ReportsModel.InitialDate).utc().format('MM/DD/YYYY')} al {moment(ReportsModel.FinalDate).utc().format('MM/DD/YYYY')}</h6>
                                </div>
                                <div className='col-12'>
                                    <table>
                                        <thead style={{ border: "solid 1px" }}>
                                            <tr>
                                                <th className="text-left"> Folio Counter </th>
                                                <th className="text-left"> Folio SAP </th>
                                                <th className="text-center">Fecha</th>
                                                <th className="text-center">Hora</th>
                                                <th className="text-center">Tipo Doc</th>
                                                <th className="text-left">Serie</th>
                                                <th className="text-right  pr-3">Total</th>
                                                <th className="text-left">Cliente</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!!DocsToPrint[0].headerRefounds && DocsToPrint[0].headerRefounds.map((refounds, index) => {
                                                return (
                                                    <tr style={{ fontSize: '12px' }}>
                                                        <td className="text-left">{refounds.NumAtCard || ''}</td>
                                                        <td className="text-left">{refounds.DocNum || ''}</td>
                                                        <td className="text-center">{moment(refounds.DocDate).utc().format('MM/DD/YYYY')}</td>
                                                        <td className="text-center">{this.DocTimeFormat(refounds.DocTime) + ' HRS'}</td>
                                                        <td className="text-center">Devolución</td>
                                                        <td className="text-left">{refounds.SeriesName}</td>
                                                        <td className="text-right pr-3">{formatNumber.new(refounds.DocTotal)}</td>
                                                        <td className="text-left">{refounds.CardName}</td>
                                                    </tr>
                                                );
                                            })}

                                            <br />

                                            <tr style={{ borderTop: "solid 1px" }}>
                                                <td colspan="5"></td>
                                                <td className="text-right"><strong>Total: </strong></td>
                                                <td className="text-right"><strong>{formatNumber.new(DocsToPrint[0].SumTotalRefounds)}</strong></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }

                        {/* FACTURAS */}
                        {ReportsModel.checkBill && DocsToPrint[0].headerBill.length > 0 &&
                            <div className='row mt-5' style={{ paddingRight: "15px" }}>
                                <div className='col-6 text-left'>
                                    <h6><strong>Facturas</strong></h6>
                                </div>
                                <div className='col-6 text-right'>
                                    <h6>Del {moment(ReportsModel.InitialDate).utc().format('MM/DD/YYYY')} al {moment(ReportsModel.FinalDate).utc().format('MM/DD/YYYY')}</h6>
                                </div>
                                <div className='col-12'>
                                    <table>
                                        <thead style={{ border: "solid 1px" }}>
                                            <tr>
                                                <th className="text-left"> Folio Counter </th>
                                                <th className="text-left"> Folio SAP </th>
                                                <th className="text-center">Fecha</th>
                                                <th className="text-center">Tipo Doc</th>
                                                <th className="text-center">Reserva</th>
                                                <th className="text-center">Crédito</th>
                                                <th className="text-left">Serie</th>
                                                <th className="text-left">Cliente</th>
                                                <th className="text-right  pr-3">Total</th>
                                                <th className="text-right  pr-3">Importe aplicado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {DocsToPrint[0].headerBill.map((bill, index) => {
                                                return (
                                                    <tr style={{ fontSize: '12px' }}>
                                                        <td className="text-left">{bill.NumAtCard || ''}</td>
                                                        <td className="text-left">{bill.DocNum || ''}</td>
                                                        <td className="text-center">{moment(bill.DocDate).utc().format('MM/DD/YYYY')}</td>
                                                        <td className="text-center">Factura</td>
                                                        <td className="text-center">{bill.isIns === 'Y' ? 'SI' : 'NO'}</td>
                                                        <td className="text-center">{bill.FCredito === 'Y' ? 'SI' : 'NO'}</td>
                                                        <td className="text-left">{bill.SeriesName}</td>
                                                        <td className="text-left">{bill.CardName}</td>
                                                        <td className="text-right pr-3">{formatNumber.new(bill.DocTotal)}</td>
                                                        <td className="text-right pr-3">{formatNumber.new(bill.PaidToDate)}</td>
                                                    </tr>
                                                );
                                            })}

                                            <br />

                                            <tr style={{ borderTop: "solid 1px" }}>
                                                <td colspan="7"></td>
                                                <td className="text-right"><strong>Total: </strong></td>
                                                <td className="text-right"><strong>{formatNumber.new(DocsToPrint[0].SumTotalBill)}</strong></td>
                                                <td className="text-right"><strong>{formatNumber.new(DocsToPrint[0].SumPaidToDateBill)}</strong></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }

                        {/* NOTAS DE CRÉDITO */}
                        {ReportsModel.checkCreditNotes &&
                            <div className='row mt-5' style={{ paddingRight: "15px" }}>
                                <div className='col-6 text-left'>
                                    <h6><strong>Notas de crédito</strong></h6>
                                </div>
                                <div className='col-6 text-right'>
                                    <h6>Del {moment(ReportsModel.InitialDate).utc().format('MM/DD/YYYY')} al {moment(ReportsModel.FinalDate).utc().format('MM/DD/YYYY')}</h6>
                                </div>
                                <div className='col-12'>
                                    <table>
                                        <thead style={{ border: "solid 1px" }}>
                                            <tr>
                                                <th className="text-left"> Folio </th>
                                                <th className="text-center">Fecha</th>
                                                <th className="text-center">Hora</th>
                                                <th className="text-center">Tipo Doc</th>
                                                <th className="text-left">Serie</th>
                                                <th className="text-right  pr-3">Total</th>
                                                <th className="text-left">Cliente</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!!DocsToPrint[0].headerCreditNotes && DocsToPrint[0].headerCreditNotes.map((creditNotes, index) => {
                                                return (
                                                    <tr style={{ fontSize: '12px' }}>
                                                        <td className="text-left">{creditNotes.NumAtCard}</td>
                                                        <td className="text-center">{moment(creditNotes.DocDate).utc().format('MM/DD/YYYY')}</td>
                                                        <td className="text-center">{this.DocTimeFormat(creditNotes.DocTime) + ' HRS'}</td>
                                                        <td className="text-center">Nota de crédito</td>
                                                        <td className="text-left">{creditNotes.SeriesName}</td>
                                                        <td className="text-right pr-3">{formatNumber.new(creditNotes.DocTotal)}</td>
                                                        <td className="text-left">{creditNotes.CardName}</td>
                                                    </tr>
                                                );
                                            })}
                                            <br />

                                            <tr style={{ borderTop: "solid 1px" }}>
                                                <td colspan="5"></td>
                                                <td className="text-right"><strong>Total: </strong></td>
                                                <td className="text-right"><strong>{formatNumber.new(DocsToPrint[0].SumTotalCreditNotes)}</strong></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }

                        {/* NOTAS DE CAJA */}
                        {ReportsModel.checkCashNotes &&
                            <div className='row mt-5' style={{ paddingRight: "15px" }}>
                                <div className='col-6 text-left'>
                                    <h6><strong>Notas de caja</strong></h6>
                                </div>
                                <div className='col-6 text-right'>
                                    <h6>Del {moment(ReportsModel.InitialDate).utc().format('MM/DD/YYYY')} al {moment(ReportsModel.FinalDate).utc().format('MM/DD/YYYY')}</h6>
                                </div>
                                <div className='col-12'>
                                    <table>
                                        <thead style={{ border: "solid 1px" }}>
                                            <tr>
                                                <th className="text-left"> Folio </th>
                                                <th className="text-center">Fecha</th>
                                                <th className="text-center">Hora</th>
                                                <th className="text-center">Tipo Doc</th>
                                                <th className="text-left">Serie</th>
                                                <th className="text-right  pr-3">Total</th>
                                                <th className="text-left">Cliente</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!!DocsToPrint[0].headerCashNotes && DocsToPrint[0].headerCashNotes.map((cashNotes, index) => {
                                                return (
                                                    <tr style={{ fontSize: '12px' }}>
                                                        <td className="text-left">{cashNotes.NumAtCard}</td>
                                                        <td className="text-center">{moment(cashNotes.DocDate).utc().format('MM/DD/YYYY')}</td>
                                                        <td className="text-center">{this.DocTimeFormat(cashNotes.DocTime) + ' HRS'}</td>
                                                        <td className="text-center">Nota de caja</td>
                                                        <td className="text-left">{cashNotes.SeriesName}</td>
                                                        <td className="text-right pr-3">{formatNumber.new(cashNotes.DocTotal)}</td>
                                                        <td className="text-left">{cashNotes.CardName}</td>
                                                    </tr>
                                                );
                                            })}

                                            <br />

                                            <tr style={{ borderTop: "solid 1px" }}>
                                                <td colspan="5"></td>
                                                <td className="text-right"><strong>Total: </strong></td>
                                                <td className="text-right"><strong>{formatNumber.new(DocsToPrint[0].SumTotalCashNotes)}</strong></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }

                        {/* ENTREGAS DIRECTAS */}
                        {ReportsModel.checkDirectDeliveries && DocsToPrint[0].headerDirectDeliveries.length > 0 &&
                            <div className='row mt-5' style={{ paddingRight: "15px" }}>
                                <div className='col-6 text-left'>
                                    <h6><strong>Entregas directas</strong></h6>
                                </div>
                                <div className='col-6 text-right'>
                                    <h6>Del {moment(ReportsModel.InitialDate).utc().format('MM/DD/YYYY')} al {moment(ReportsModel.FinalDate).utc().format('MM/DD/YYYY')}</h6>
                                </div>
                                <div className='col-12'>
                                    <table>
                                        <thead style={{ border: "solid 1px" }}>
                                            <tr>
                                                <th className="text-left"> Folio Counter </th>
                                                <th className="text-left"> Folio SAP </th>
                                                <th className="text-center">Fecha</th>
                                                <th className="text-center">Tipo Doc</th>
                                                <th className="text-left">Serie</th>
                                                <th className="text-left">Cliente</th>
                                                <th className="text-right  pr-3">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {DocsToPrint[0].headerDirectDeliveries.map((directDeliveries, index) => {
                                                return (
                                                    <tr style={{ fontSize: '12px' }}>
                                                        <td className="text-left">{directDeliveries.NumAtCard || ''}</td>
                                                        <td className="text-left">{directDeliveries.DocNum || ''}</td>
                                                        <td className="text-center">{moment(directDeliveries.DocDate).utc().format('MM/DD/YYYY')}</td>
                                                        <td className="text-center">Entrega directa</td>
                                                        <td className="text-left">{directDeliveries.SeriesName}</td>
                                                        <td className="text-left">{directDeliveries.CardName}</td>
                                                        <td className="text-right pr-3">{formatNumber.new(directDeliveries.DocTotal)}</td>
                                                    </tr>
                                                );
                                            })}

                                            <br />

                                            <tr style={{ borderTop: "solid 1px" }}>
                                                <td colspan="5"></td>
                                                <td className="text-right"><strong>Total: </strong></td>
                                                <td className="text-right"><strong>{formatNumber.new(DocsToPrint[0].SumTotalDirectDeliveries)}</strong></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }

                    </div>

                </td></tr></table>
            </>
        )
    }
}

export default GeneralInvoiceDelivey